import { render, staticRenderFns } from "./PartnerSettings.vue?vue&type=template&id=e6d7edde&"
import script from "./PartnerSettings.vue?vue&type=script&lang=js&"
export * from "./PartnerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports